// Data sevice
import Axios from './Axios';

class LicensesService {
    index() {
        return Axios({
            method: "GET",
            url: 'licenses',
        });
    }
    periods() {
        return Axios({
            method: "GET",
            url: 'periods',
        });
    }
    store(item) {
        return Axios({
            method: "POST",
            url: 'licenses', 
            data: item
        });
    }
    update(item) {
        return Axios({
            method: "PATCH",
            url: 'licenses/' + item.id, 
            data: item
        });
    }
    delete(item) {
        return Axios({
            method: "DELETE",
            url: 'licenses/' + item.id,
        });
    }
}

export default new LicensesService();
